// @ai-generated 2026-07-28T15:01:24+00:00 by niklas.eicker@tngtech.com using Claude Opus 5
import { AUFTRAG_API } from '@Constants/backendConstants';
import { EnumRequisitionStatus } from '@Model';
import {
    EnumDirection,
    EnumFilterExpressionOperation,
    EnumOperation,
    toCalendarDay,
} from '@synqo/frontend-component-library';
import { useQuery } from '@tanstack/react-query';
import { useListApi } from '@Hooks/useListApi';
import { RequisitionsRepository } from '@Repositories/Auftragsbearbeitung';

function startOfToday(): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
}

/**
 * The earliest accepted requisition whose desired date has not passed, whatever it is about. Needs its
 * own query — the nearest appointment is not necessarily among the most recently created orders.
 */
// @ai-generated 2026-09-25T13:19:55+00:00 by matthias.gessinger@synqony.com using Claude Opus 5.5 (1M context)
export function useNextRequisition(enabled: boolean) {
    const { loadPage } = useListApi(RequisitionsRepository, AUFTRAG_API, ['Site', 'ContainerActions']);

    const today = startOfToday();

    const { data, isLoading } = useQuery({
        queryFn: () =>
            loadPage({
                page_no: 0,
                page_size: 1,
                full_text_search: '',
                sort_columns: [{ column_name: 'date_from', direction: EnumDirection.ASC }],
                filter_columns: {
                    operation: EnumFilterExpressionOperation.And,
                    filters: [
                        {
                            field: 'ProcessState',
                            value: String(EnumRequisitionStatus.InProgress),
                            operator: EnumOperation.Equal,
                        },
                        { field: 'DateFrom', value: toCalendarDay(today), operator: EnumOperation.GreaterEqual },
                    ],
                },
            }),
        // The day is part of the key so the query follows along over midnight instead of
        // answering from a cache that was filled yesterday.
        queryKey: ['requisitions', 'next', today.getTime()],
        enabled,
    });

    return {
        nextRequisition: data?.items[0],
        isLoading,
    };
}
